module.exports = global["Cookies"] = require("-!./js.cookie.js");


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/js-cookie/src/js.cookie.js
// module id = 6bgg
// module chunks = 20